// 📁 components/BoutonModifierPeriodes.jsx
import React from "react";
import { Box, Button,useMediaQuery } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit"; // ou EditCalendarIcon si tu préfères
import { useLanguage } from "../context/LanguageContext.js";

const BoutonModifierPeriodes = ({ onClick }) => {
  const isMobile = useMediaQuery("(max-width:600px)");
  const { t } = useLanguage();

  return (
    <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
    <Button 
    variant="contained" 
    onClick={onClick} 
    startIcon={<EditIcon sx={{ color: "#fff !important" }} />}
    sx={{
      color: "#fff",    
      backgroundColor: "#3399FF !important",          // texte
      borderColor: "#3399FF",        // bordure
      display: "flex",
      flexDirection: "row", // ou "column" si tu veux empiler
      gap: 2,               // 1 = 8px, 2 = 16px, etc.
      marginLeft: 1,
      marginTop: 1,
      fontWeight: "bold",
      fontSize: isMobile ? "0.5rem" : "0.7rem",
      transition: "all 0.3s ease",
      minHeight: isMobile ? "32px" : "40px",
      paddingX: 3,
      paddingY: 2,
      borderRadius: 1,
        '&:hover': {
          backgroundColor: "#027bb5 !important",  // fond au survol
          color: "#fff",               // texte au survol
          transform: "scale(1.05)"
          },
      }}
    >
      {t('ModifyPeriod')}
    </Button>
    </Box>
  );
};

export default BoutonModifierPeriodes;
